import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './locations.actions.js';
import getters from './locations.getters.js';
import mutations from './locations.mutations.js';
import state from './locations.state.js';

BaseStore.registerModule('locations', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('locations');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
